import React from 'react'
import { t } from 'ttag'

import { fetchProjects } from 'api/projects'
import { Form } from 'components/shared/Form/Form'
import { statusSelectOptions } from 'utils/translate'
import { POSITION_FIELD, STATUS_FIELD } from './model'

export const MoveResourceForm = ({
  control,
  formState,
  hasInterviewModule,
}) => {
  const resultsMatcher = ({ id, name }) => ({ label: name, value: id })

  return (
    <Form>
      <Form.Field
        error={formState?.errors[POSITION_FIELD]?.message}
        field="combobox"
        label={t`Position`}
        name={POSITION_FIELD}
        fetchOptions={[fetchProjects, resultsMatcher]}
        isSearchable
        {...{ control }}
      />
      <Form.Field
        error={formState?.errors[STATUS_FIELD]?.message}
        field="combobox"
        label={t`Status`}
        name={STATUS_FIELD}
        options={statusSelectOptions({ hasInterviewModule })}
        {...{ control }}
      />
    </Form>
  )
}
